"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserWireMessage = exports.ENABLE_REALTIME_UNSUBSCRIBE_FIX_FEATURE_FLAG = exports.REALTIME_CONNECTION_RETRY_TIME = void 0;
var Logger_1 = __importDefault(require("../Core/Logger"));
var Polly_1 = __importDefault(require("../Core/Polly"));
var PubSubEvents_1 = require("./PubSubEvents");
var RealtimeConnection_1 = require("./RealtimeConnection");
exports.REALTIME_CONNECTION_RETRY_TIME = 5000;
exports.ENABLE_REALTIME_UNSUBSCRIBE_FIX_FEATURE_FLAG = 'enable_realtime_unsubscribe_fix';
var UserWireMessage = /** @class */ (function () {
    function UserWireMessage(user) {
        this.id = user.id;
        this.auth_token = user.authentication_token;
        this.bringg_user_id = user.uuid;
    }
    return UserWireMessage;
}());
exports.UserWireMessage = UserWireMessage;
var PersistentConnection = /** @class */ (function () {
    function PersistentConnection(session) {
        this.wrappedHandlersByEvent = new Map();
        this.session = session;
    }
    PersistentConnection.wrapEventHandler = function (eventName, initialHandler, additionalHandler) {
        return function (message) {
            if (additionalHandler) {
                additionalHandler(eventName, message);
            }
            return initialHandler(message);
        };
    };
    PersistentConnection.init = function (session) {
        return __awaiter(this, void 0, void 0, function () {
            var _this, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _this = new PersistentConnection(session);
                        _a = _this;
                        return [4 /*yield*/, RealtimeConnection_1.RealtimeConnection.connect(session.config.getMonitoringEndpoint(), _this)];
                    case 1:
                        _a.connection = _b.sent();
                        return [2 /*return*/, _this];
                }
            });
        });
    };
    PersistentConnection.prototype.handshake = function (conn) {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            _this_1.publishInternal(conn, PubSubEvents_1.USER_CONNECT_EVENT, new UserWireMessage(_this_1.session.user), function () {
                                _this_1.publishInternal(conn, PubSubEvents_1.SUBSCRIBE_AS_ADMIN_EVENT, new UserWireMessage(_this_1.session.user), function () {
                                    _this_1.session.sendDataEvent('subscribed as admin', null);
                                    resolve();
                                });
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PersistentConnection.prototype.onConnect = function (connection) {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Polly_1.default()
                            .handle(function (er) {
                            Logger_1.default.error("Failed establishing persistent connection to realtime, retry again in ".concat(exports.REALTIME_CONNECTION_RETRY_TIME / 1000, " seconds, ").concat(er));
                            return er.message !== 'timeout';
                        })
                            .waitAndRetry([exports.REALTIME_CONNECTION_RETRY_TIME])
                            .forever()
                            .executeForPromise(function () { return _this_1.handshake(connection); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PersistentConnection.prototype.onDisconnect = function (connection) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    PersistentConnection.prototype.onReconnect = function (connection) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    PersistentConnection.prototype.publishInternal = function (connection, ev, mess, ackCallback) {
        connection.socket.emit(ev.name, mess, ackCallback);
    };
    PersistentConnection.prototype.subscribeInternal = function (connection, eventType, handler) {
        if (!this.isUnsubscribeFixEnabled()) {
            connection.socket.on(eventType.name, this.createWrappedHandler(eventType.name, handler));
            return;
        }
        this.subscribeWithWrappedHandler(connection, eventType.name, handler);
    };
    PersistentConnection.prototype.unsubscribe = function (eventType, handler) {
        if (!this.isUnsubscribeFixEnabled()) {
            this.connection.socket.off(eventType.name, handler);
            return;
        }
        this.unsubscribeWrappedHandler(eventType.name, handler);
    };
    PersistentConnection.prototype.publish = function (ev, mess, ackCallback) {
        this.publishInternal(this.connection, ev, mess, ackCallback);
    };
    PersistentConnection.prototype.subscribe = function (eventType, handler) {
        this.subscribeInternal(this.connection, eventType, handler);
    };
    PersistentConnection.prototype.dispose = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connection.disconnect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PersistentConnection.prototype.createWrappedHandler = function (eventName, handler) {
        return PersistentConnection.wrapEventHandler(eventName, handler, this.session.sendDataEvent);
    };
    PersistentConnection.prototype.isUnsubscribeFixEnabled = function () {
        var _a;
        var merchantFeatureFlags = (((_a = this.session.merchant) === null || _a === void 0 ? void 0 : _a.feature_flags) || {});
        return !!merchantFeatureFlags[exports.ENABLE_REALTIME_UNSUBSCRIBE_FIX_FEATURE_FLAG];
    };
    PersistentConnection.prototype.getEventHandlers = function (eventName) {
        return this.wrappedHandlersByEvent.get(eventName);
    };
    PersistentConnection.prototype.createEventHandlers = function (eventName) {
        var handlers = new Map();
        this.wrappedHandlersByEvent.set(eventName, handlers);
        return handlers;
    };
    PersistentConnection.prototype.getOrCreateEventHandlers = function (eventName) {
        var _a;
        return (_a = this.getEventHandlers(eventName)) !== null && _a !== void 0 ? _a : this.createEventHandlers(eventName);
    };
    PersistentConnection.prototype.subscribeWithWrappedHandler = function (connection, eventName, handler) {
        var eventHandlers = this.getOrCreateEventHandlers(eventName);
        var originalHandler = handler;
        if (eventHandlers.has(originalHandler)) {
            return;
        }
        var wrappedHandler = this.createWrappedHandler(eventName, handler);
        eventHandlers.set(originalHandler, wrappedHandler);
        connection.socket.on(eventName, wrappedHandler);
    };
    PersistentConnection.prototype.unsubscribeWrappedHandler = function (eventName, handler) {
        if (!handler) {
            this.connection.socket.off(eventName);
            this.wrappedHandlersByEvent.delete(eventName);
            return;
        }
        var eventHandlers = this.getEventHandlers(eventName);
        var originalHandler = handler;
        var wrappedHandler = eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.get(originalHandler);
        if (!wrappedHandler) {
            this.connection.socket.off(eventName, handler);
            return;
        }
        this.connection.socket.off(eventName, wrappedHandler);
        eventHandlers.delete(originalHandler);
        if (eventHandlers.size === 0) {
            this.wrappedHandlersByEvent.delete(eventName);
        }
    };
    return PersistentConnection;
}());
exports.default = PersistentConnection;
//# sourceMappingURL=PersistentConnection.js.map